import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, vShow as _vShow, withDirectives as _withDirectives } from "vue"
import _imports_0 from '../assets/images/right_arrow.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "blue-line" }, null, -1)
const _hoisted_2 = {
  key: 0,
  src: _imports_0,
  class: "arrow-ico"
}
const _hoisted_3 = {
  key: 0,
  class: "methods"
}
const _hoisted_4 = ["id"]
const _hoisted_5 = { class: "question-other" }
const _hoisted_6 = { class: "other-title" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "other-title-left" }, "解析", -1)
const _hoisted_8 = ["id"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "other-title sp" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "other-title-left" }, "答案")
], -1)
const _hoisted_10 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["question-detail", {'pb4': _ctx.isList || (!_ctx.isList && _ctx.isShowMore)}])
  }, [
    _createElementVNode("h4", null, [
      _hoisted_1,
      _createTextVNode("题目" + _toDisplayString(_ctx.questionIndex > 0 ? _ctx.questionIndex : '') + " ", 1),
      (_ctx.isList)
        ? (_openBlock(), _createElementBlock("img", _hoisted_2))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (_ctx.isWrongQuestion)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (_ctx.questionData.is_wrong_question)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.cancelWrongQuestion(_ctx.questionData.nry_question_id))),
                        class: "cancel-wrong"
                      }, "移出错题本"))
                    : (_openBlock(), _createElementBlock("span", {
                        key: 1,
                        class: "join-wrong",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addWrongList(_ctx.questionData.nry_question_id)))
                      }, "加入错题本"))
                ], 64))
              : (_openBlock(), _createElementBlock("span", {
                  key: 1,
                  class: _normalizeClass(["collection-btn", {'cancel-collection':_ctx.questionData.collection}]),
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.collectionQuestion && _ctx.collectionQuestion(...args)))
                }, _toDisplayString(_ctx.questionData.collection?'已收藏': '添加收藏'), 3))
          ], 64))
    ]),
    (_ctx.showKnowledgePoint && _ctx.knowledgePoint.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.knowledgePoint, (point, labelIndex) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "tag-item",
              key: labelIndex
            }, _toDisplayString(point), 1))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "question-title",
      id: `questionTitle_${_ctx.questionIndex}`
    }, null, 8, _hoisted_4),
    (!_ctx.isList)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _withDirectives(_createElementVNode("div", {
            class: "view-analysis",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.viewAnalysis && _ctx.viewAnalysis(...args)))
          }, "查看题目解析", 512), [
            [_vShow, !_ctx.isShowMore]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", {
                class: "other-title-right",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.viewAnalysis && _ctx.viewAnalysis(...args)))
              }, "收起解析")
            ]),
            _createElementVNode("div", {
              class: "question-analysis question-commond",
              id: `questionAnalysis_${_ctx.questionIndex}`
            }, null, 8, _hoisted_8),
            _hoisted_9,
            _createElementVNode("div", {
              class: "question-answer question-commond",
              id: `questionAnswer_${_ctx.questionIndex}`
            }, null, 8, _hoisted_10)
          ], 512), [
            [_vShow, _ctx.isShowMore]
          ])
        ], 64))
      : _createCommentVNode("", true)
  ], 2))
}